import type { CSSProperties } from "react";
import { colors, radius, typography } from "../../design-system";

export const iconWrapStyle: CSSProperties = {
  width: 38,
  height: 38,
  background: colors.brandSoft,
  borderRadius: radius.lg,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

export const thLeft: CSSProperties = {
  textAlign: "left",
  padding: "10px 12px",
  ...typography.labelUppercase,
  color: colors.textMuted,
  whiteSpace: "nowrap",
  background: colors.bgCardActive,
  borderBottom: "1px solid " + colors.borderSubtle,
};

export const thRight: CSSProperties = { ...thLeft, textAlign: "right" };

export const itemTd = (extra: CSSProperties = {}): CSSProperties => ({
  padding: "10px 12px",
  ...typography.bodySm,
  fontFeatureSettings: '"tnum" 1',
  ...extra,
});

export const backButtonStyle: CSSProperties = {
  background: "none",
  border: "none",
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  ...typography.bodySm,
  color: colors.textSecondary,
  padding: 0,
  fontFamily: typography.fontFamily,
};